/**
 * @generated SignedSource<<9d169d163b8a2a3c79709938d3533b45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpAuctionItems_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "HpAuctionItems_componentModule";
};
export type HpAuctionItems_componentModule$key = {
  readonly " $data"?: HpAuctionItems_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpAuctionItems_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpAuctionItems_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    }
  ],
  "type": "AuctionItemsModule",
  "abstractKey": null
};

(node as any).hash = "e78ffc61a7d18164e94ce4878b1276a3";

export default node;
